import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-be",
  "use": "icon-flag-be-usage",
  "viewBox": "0 0 1542 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1542 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-be\"><defs><style type=\"text/css\"></style></defs><path d=\"M7.53865 1017.717791h1519.038037V7.53865H7.53865v1010.179141z m1521.550921 2.512884v-3.769325 3.769325zM1.256442 1024V0H1532.858896V1022.743558H1.256442z\" fill=\"#353636\" p-id=\"8888\" /><path d=\"M3.769325 3.769325h508.858896v1016.46135H3.769325z\" fill=\"#231815\" p-id=\"8889\" /><path d=\"M512.628221 3.769325h508.858896v1016.46135H512.628221z\" fill=\"#FBDC00\" p-id=\"8890\" /><path d=\"M1021.487117 3.769325h508.858895v1016.46135H1021.487117z\" fill=\"#DD2A1B\" p-id=\"8891\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-be.svg
// module id = L/kk
// module chunks = 24